<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.875 7.21747L9.00293 6.08954L10.2404 7.32698L6.99665 10.5707L3.75293 7.32698L4.99037 6.08954L6.125 7.22417V1.75H7.875V7.21747ZM13.125 7V13.125H0.875V7.00242H2.625V11.375H11.375V7H13.125Z"
      fill="currentColor"
    />
  </svg>
</template>
